import { render, staticRenderFns } from "./EventAccess.vue?vue&type=template&id=3f40a6ce&scoped=true&"
import script from "./EventAccess.vue?vue&type=script&lang=js&"
export * from "./EventAccess.vue?vue&type=script&lang=js&"
import style0 from "./EventAccess.vue?vue&type=style&index=0&id=3f40a6ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f40a6ce",
  null
  
)

export default component.exports